import PropTypes from 'prop-types';

export const CouponLength = 16;
export const i18nPropType = PropTypes.shape({
  getString: PropTypes.func.isRequired,
});

export const GenericErrorKey = _TL_('An error occured while validating the coupon, please try again.');

export const CouponCodeFieldId = 'CouponCode';
